<template>
  <uiv-tooltip
    ref="uivPopup"
    v-bind="$attrs"
    v-on="$listeners"
    @show="a11yDescribe"
    @hide="a11yUndescribe">
    <slot/>
  </uiv-tooltip>
</template>

<script>
import { Tooltip } from 'uiv'

export default {
  name: 'A11yTooltip',
  components: { 'uiv-tooltip': Tooltip },
  inheritAttrs: false,
  methods: {
    a11yDescribe() {
      const uiv = this.$refs.uivPopup
      const popup = uiv && uiv.$refs.popup
      const trigger = uiv && uiv.triggerEl
      if (!popup || !trigger) return
      if (!popup.id) {
        popup.id = `a11y-popup-${this._uid}`
      }
      if (!popup.getAttribute('role')) {
        popup.setAttribute('role', 'tooltip')
      }
      const ids = (trigger.getAttribute('aria-describedby') || '')
        .split(/\s+/)
        .filter(Boolean)
      if (!ids.includes(popup.id)) {
        ids.push(popup.id)
      }
      trigger.setAttribute('aria-describedby', ids.join(' '))
    },
    a11yUndescribe() {
      const uiv = this.$refs.uivPopup
      const popup = uiv && uiv.$refs.popup
      const trigger = uiv && uiv.triggerEl
      if (!popup || !trigger) return
      const ids = (trigger.getAttribute('aria-describedby') || '')
        .split(/\s+/)
        .filter(Boolean)
        .filter((id) => id !== popup.id)
      if (ids.length) {
        trigger.setAttribute('aria-describedby', ids.join(' '))
      } else {
        trigger.removeAttribute('aria-describedby')
      }
    },
  },
  beforeDestroy() {
    this.a11yUndescribe()
  },
}
</script>
